module.exports = __webpack_public_path__ + "3578b58e971ebd180aaa31891a67a7b3.pdf";